import type { EditAssetWorkflowOptions } from '../../types';

export const editLabelAugmentation: EditAssetWorkflowOptions = {
  workflowKey: 'editLabelAugmentationsWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'labelAugmentation',
  workflowIndex: 1,
  workflowName: 'Edit Label Augmentations',
  workflowDescription: `Edit the details of an existing label augmentations`,
  workflowAssets: ['labelAugmentation'],
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Label Augmentation ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this label augmentation',
        description:
          'This is optional but will allow you to more easily reference this label augmentation in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What will you call this label augmentation?',
        description: 'How will you refer to this set of label augmentation ',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 4,
        prompt: 'Enter a description (optional):',
        description: '',
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'matchShipmentTag',
      workflowStepNavigationName: 'Match Shipment Tag?',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Should this augmentation only be applied to certain shipment tags?',
        description: '',
        help: '',
        options: [
          { optionText: 'Yes', optionValue: true },
          { optionText: 'No', optionValue: false },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
      markComplete: true,
      assetToWorkflowStateMapping: {
        assetProperty: 'shipmentTagToMatch',
        computeFn: (assetProperty) => {
          return !!assetProperty;
        },
      },
    },
    {
      workflowStepKey: 'shipmentTagToMatch',
      workflowStepNavigationName: 'Shipment Tag To Match',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What shipment tag should this apply to?',
        description: ``,
        help: '',
      },
      workflowStepConditionalMatcher: [
        {
          workflowStepKey: 'matchShipmentTag',
          schema: { type: 'boolean', const: true },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'shipmentTagToMatch',
        workflowStateValueOverride: (wfs: any) => {
          return !wfs.shipmentTagToMatch ? null : wfs.shipmentTagToMatch;
        },
      },
    },
    {
      workflowStepKey: 'injectionPosition',
      workflowStepNavigationName: 'Injection Position',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Where should this augmentation get injected onto the label?',
        description: 'When the label gets generated should the augmentation appear at the bottom or top',
        help: '',
        options: [
          { optionText: 'Bottom', optionValue: 'bottom' },
          { optionText: 'Top', optionValue: 'top' },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'injectionPosition',
      },
    },
    {
      workflowStepKey: 'zplEntry',
      workflowStepNavigationName: 'ZPL Entry',
      workflowComponent: {
        workflowComponentType: 'zplEntry',
        prompt: 'Enter the ZPL for your augmentation',
        description: 'Use the editor to enter the zpl for your augmentation',
        help: '',
      },
      calculatedComponentProps: {
        defaultValue: {
          type: 'asset',
          property: 'zpl',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'zpl',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this label augmentation belong to a specific tenant?',
        description: '',
        help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
        optional: true,
      },
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
      calculatedComponentProps: {
        assetId: {
          type: 'asset',
          property: 'labelAugmentationId',
        },
      },
      optional: true,
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Origin Summary',
        description: 'The FC Origin will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
